import { Setting } from '../services/setting';
import { controlsSettingBase } from './controls-setting-base';

export function configurationSetter(setting: Partial<Setting>): Setting {
  if (setting.overwrittenControls) {
    if (!setting.overwrittenControls.boolean) {
      setting.overwrittenControls.boolean = controlsSettingBase.boolean;
    }
    if (!setting.overwrittenControls.page) {
      setting.overwrittenControls.page = controlsSettingBase.page;
    }
    if (!setting.overwrittenControls.panel) {
      setting.overwrittenControls.panel = controlsSettingBase.panel;
    }
    if (!setting.overwrittenControls.panel) {
      setting.overwrittenControls.panel = controlsSettingBase.panel;
    }
    if (!setting.overwrittenControls.percent) {
      setting.overwrittenControls.percent = controlsSettingBase.percent;
    }
    if (!setting.overwrittenControls.textfield) {
      setting.overwrittenControls.percent = controlsSettingBase.textfield;
    }
    if (!setting.overwrittenControls.question) {
      setting.overwrittenControls.question = controlsSettingBase.question;
    }
  } else {
    setting.overwrittenControls = controlsSettingBase;
  }

  return setting;
}
